import React from 'react';
import Menutest from './menu.js';
import '../just.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import axios from 'axios';
import {Checkbox} from 'semantic-ui-react';
import { API_BASE_URL } from "../utils/endpoints";


class AddSenderID extends React.Component {

    state = {
        sender_id:'',
        account:[],
        options_sender:[],
        selectedValues:[],
        enable:false,
    }


    onChangeaccount=event=>{
        
       

        
       const newArray = [];
       var i;
       for(i=0;i<event.length;i++)
         {
           if(newArray.includes(event[i].value) === false){
             newArray.push(event[i].value);
                 }
               }
     this.setState({selectedValues: newArray}, function () {
     });
       
    }


    onChangesenderid=event=>{
        this.setState({sender_id:event.target.value});
        
    }


    componentDidMount(){
        var lang=i18n.language;
        if(lang ==="ar")
        {
          document.querySelector('.form_add_form').style = 'text-align:right;';       
       
        
        }
  
  
  
      }
      back=()=>{
        window.location="SenderID";
    }
    Adv=event=>{
      if(this.state.enable === false){
        this.setState({enable:true});
    }
    else{
        this.setState({enable:false});
}
    }
      handleSubmit=event=>{
        event.preventDefault();
        var token=reactLocalStorage.get('accessToken');
        const user = {
          'sender_id': this.state.sender_id,
          "isAdv":this.state.enable,
        };
        var data=user;
       
  
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
          apiBaseUrl = API_BASE_URL + "/core/user/rest/senderid/createSenderId";
        }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/createSenderId";
        }
        var headers = {
         'Content-Type': 'application/json',
         'token':token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {
  
        if(response.status === 200)
        {
           
   
            if(response.data.status)
            {
                window.location='SenderID'
            }
  
        }
        else if(response.status === 204){
        console.log("Something wrong");
  
  
  
        }
        else{
        console.log("Something wrong");
  
  
        }
        })
        .catch(function (error) {
        console.log(error);
        });
      }



    render(){
        return(
            <div className="big_div">
            <Menutest/>
                      <div className="actionMenu">
                      <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} className="form_add_form">
                <p className="h4 text-center py-4 text_style blues_color"> {i18n.t('create_sender_id.label')}</p>
                <div className="step_one">
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('sender_id.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="name"
                  onChange={this.onChangesenderid}
                />
                <br />

                <Checkbox label= {i18n.t('Adv.label')} style={{width:'20%'}} onClick={this.Adv}  style={{ width: '34%'}}/>

               
                <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_green">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_green">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>
                 </div>

                 </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
                      </div>
                      </div></div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (AddSenderID);